// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagePreviewSpace_wrapper__2oDFe","image":"ImagePreviewSpace_image__d5MK9"};